export class LocalStorageState {
  clearWatch() {
    this.unWatchLsState.forEach(cb => cb());
    this.unWatchLsState = [];
  }
  constructor(uc, renderer) {
    this.unWatchLsState = [];
    this.cacheKey = uc.config.userCacheKey;
    this.pageletId = renderer.ucRootRenderer.ucPagelet.id || '';
    const getSlotKey = () => {
      var _renderer$ucScopedSlo;
      if (renderer.ucIsRoot) return '';
      return `${(_renderer$ucScopedSlo = renderer.ucScopedSlotOwner) === null || _renderer$ucScopedSlo === void 0 || (_renderer$ucScopedSlo = _renderer$ucScopedSlo.comp) === null || _renderer$ucScopedSlo === void 0 ? void 0 : _renderer$ucScopedSlo.componentId}_${renderer.ucScopedSlotId}`;
    };
    this.slotKey = getSlotKey();
  }
  getAll() {
    return JSON.parse(localStorage.getItem(this.cacheKey) || '{}');
  }
  getKey(stateId) {
    return `${this.pageletId}_${this.slotKey}_${stateId}`;
  }
  get(stateId) {
    if (stateId === undefined) return undefined;
    return this.getAll()[this.getKey(stateId)];
  }
  set(stateId, value) {
    const instance = this.getAll();
    instance[this.getKey(stateId)] = value;
    localStorage.setItem(this.cacheKey, JSON.stringify(instance));
  }
}
//# sourceMappingURL=localStorageState.js.map
